import { render, staticRenderFns } from "./ProjectUpload.vue?vue&type=template&id=54d5804c&scoped=true"
import script from "./ProjectUpload.vue?vue&type=script&lang=js"
export * from "./ProjectUpload.vue?vue&type=script&lang=js"
import style0 from "./ProjectUpload.vue?vue&type=style&index=0&id=54d5804c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d5804c",
  null
  
)

export default component.exports